<template>
    <div v-if="!loading" class="pb-2">
        <h3 class="text-primary mt-50">گزارش شارژ حساب پیامک</h3>
        <div class="mt-2">
            <div>
                <b-card v-if="chargesHistoryList.length" class="p-0" no-body>
                    <b-overlay :show="loadingChargesHistory" variant="transparent" opacity="1" blur="3px" rounded="sm">
                        <b-table responsive :items="chargesHistoryList" :fields="fieldsChargesHistory" class="mb-0">
                            <template #cell(createdAt)="data">
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </template>
                            <template #cell(amount)="data">
                                {{ data.item.amount.toLocaleString('fa-IR') }}
                            </template>
                            <template #cell(status)="data">
                                <b-badge :variant="payment_StatusVariant(data.item.status)" pill>
                                    {{ payment_Status(data.item.status) }}
                                </b-badge>
                            </template>
                        </b-table>
                    </b-overlay>
                </b-card>
                <b-card v-else class="text-center py-4">
                    موردی وجود ندارد
                </b-card>
                <b-pagination align="center" @input="getSmsChargesHistory" v-model="parameters.pageIndex"
                    :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
            </div>
        </div>

    </div>
</template>

<script>
import { BCard, BCardText, BRow, BCol, BButton, BTable, BPagination, BSpinner, BBadge, BOverlay } from 'bootstrap-vue';
import { storeService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BRow,
        BCol,
        BButton,
        BTable,
        BPagination,
        BSpinner,
        BBadge,
        BOverlay
    },
    data() {
        return {
            loading: true,
            loadingChargesHistory: false,
            storeId: null,
            fieldsChargesHistory: [
                {
                    key: 'id',
                    label: 'شماره پیگیری',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'amount',
                    label: 'مبلغ (ریال)',
                },
                {
                    key: 'status',
                    label: 'وضعیت',
                },
                {
                    key: 'bankTransactionCode',
                    label: 'شماره تراکنش بانک',
                },
            ],
            chargesHistoryList: [],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null
            },
        }
    },
    computed: {
        payment_Status() {
            return (status) => {
                if (status == 0) {
                    return 'در انتظار پرداخت'
                }
                if (status == 1) {
                    return 'پرداخت نشده'
                }
                if (status == 2) {
                    return 'پرداخت شده'
                }
            }
        },
        payment_StatusVariant() {
            return (status) => {
                if (status == 0) {
                    return 'light-warning'
                }
                if (status == 1) {
                    return 'light-danger'
                }
                if (status == 2) {
                    return 'light-success'
                }
            }
        },
    },
    methods: {
        getSmsChargesHistory() {
            this.loadingChargesHistory = true
            storeService.smsChargesHistory(this.storeId, this.parameters).then(({ data }) => {
                setTimeout(() => {
                    this.parameters.totalCount = data.totalCount
                    this.chargesHistoryList = data.items
                    this.loadingChargesHistory = false
                    this.loading = false
                }, 369)
            })
        }
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getSmsChargesHistory()
    },
};
</script>